/** Set crew: the two Service Line crew binds, as a submit Form so `wb-field` owns the control chrome. */
import { ActivityEntityName, SectionLayout, ServiceLine, SurfaceSchema, SurfaceType } from '@jms/model';
import { defineSurfaceSchema } from '@workbuddy/ui/v2/surface.engine';

/** What the dialog edits — the same two binds the Service Line Detail Crew section shows. */
export type OutlineSetCrewFormModel = Pick<ServiceLine, 'defaultContractor' | 'defaultResources'>;

/**
 * One PropertyList section, the same layout and the same two field labels as the Crew section of
 * `service.line.detail.schema.ts`, so a user who sets crew from the outline and a user who sets it
 * on the line itself are looking at the same control.
 */
export function buildOutlineSetCrewSchema(): SurfaceSchema {

  return defineSurfaceSchema(ActivityEntityName.ServiceLine, SurfaceType.Form)
    .model<OutlineSetCrewFormModel>()
    .submitLabel('Apply')
    .body(body => body
      .section('crew', section => section
        .layout(SectionLayout.PropertyList)
        .columns(1)
        .field({ bind: 'defaultContractor', autofocus: true, metadata: { displayName: 'Contractor' } })
        .field({ bind: 'defaultResources', metadata: { displayName: 'Resources' } })))
    .build();
}
